import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./style/main.css";
// Components
import StoryPage from "./pages/StoryPage/StoryPage";

interface state {}

export default class App extends Component<{}, state> {
	state: state = {};
	render() {
		return (
			<Router>
				<Switch>
					<Route exact path="/interactive">
						<StoryPage />
					</Route>
				</Switch>
			</Router>
		);
	}
}
